import { render, staticRenderFns } from "./SubGoalSettingsContent.vue?vue&type=template&id=d9c7f8fe"
import script from "./SubGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./SubGoalSettingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports